























import { computed, defineComponent, ref, PropType } from '@vue/composition-api';
import { MenuConfigItemChild } from '../type';
import { fnIsRouteMatch } from '../util';

export default defineComponent({
  name: 'MenuSelector',
  props: {
    /** 菜单名 */
    name: String,
    menus: {
      type: Array as PropType<MenuConfigItemChild[]>,
      default: () => [],
    },
  },
  setup(props, { root, emit }) {
    /** 1. el-selector避免鼠标移动消失特殊处理 */
    let hideTimer = -1;
    const menuSelectorRef = ref<any>();

    const mouseenter = (e) => {
      const refDom = menuSelectorRef.value;
      if (!refDom) {
        return console.error('dom missing');
      }
      if (refDom || refDom.$refs.popper.$el.contains(e.target)) {
        clearTimeout(hideTimer);
        refDom.visible = true;
      }
      const show = () => {
        clearTimeout(hideTimer);
        refDom.visible = true;
      };
      const hide = () => {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          refDom.visible = false;
        }, 150);
      };
      refDom.$refs.popper.$el.removeEventListener('mouseover', show, false);
      refDom.$refs.popper.$el.removeEventListener('mouseleave', hide, false);
      refDom.$refs.popper.$el.addEventListener('mouseover', show, false);
      refDom.$refs.popper.$el.addEventListener('mouseleave', hide, false);
    };
    const mouseleave = () => {
      const refDom = menuSelectorRef.value;
      if (!refDom) {
        return console.error('dom missing');
      }
      if (refDom) {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          refDom.visible = false;
        }, 150);
      }
    };

    /** 2. 行为处理 */
    const fnHandleChange = (e) => {
      emit('change', props.menus[e]);
    };
    const fnVisibleChange = (e) => {
      if (!e) return;
      const refDom = menuSelectorRef.value;
      if (!refDom) return;
      refDom.options.forEach((element) => {
        element.hover = false;
      });
    };

    /** 3. 渲染 */
    const innerOptions = computed(() => props.menus.map((item, index) => ({
      value: index,
      label: item.name,
    })));
    /** 核心逻辑：根据路由匹配获得的当前组件value */
    const innerValue = computed(() => {
      const { menus } = props;
      const targets = menus.filter(item => fnIsRouteMatch(item, root.$route));
      const targetLength = targets.length;
      // 1. 没有匹配的，直接return
      if (!targetLength) return '';

      // 2. 有匹配的，返回第一个
      if (targetLength > 1) console.error('请检查路由配置是否正确', targets);
      return menus.indexOf(targets[0]);
    });

    /** 一级菜单是否高亮 */
    const isActive = computed(() => typeof innerValue.value === 'number' && innerValue.value >= 0);

    return {
      innerValue,
      innerOptions,
      menuSelectorRef,
      isActive,
      mouseenter,
      mouseleave,
      fnHandleChange,
      fnVisibleChange,
    };
  },
});
